class ProductTabsStickyCTA {
  constructor(stickyCta) {
    this.stickyCta = stickyCta;
    this.tabs = stickyCta.querySelectorAll('.sticky-cta__tab');
    this.topButton = stickyCta.querySelector('[data-scroll-top]');
    this.switchPoint = 0;

    this.tabs.forEach((tab) => {
      tab.classList.remove('is-active');
    });

    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleTopClick = this.handleTopClick.bind(this);
    this.recalculateAndUpdate = this.recalculateAndUpdate.bind(this);

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });
    window.addEventListener('load', this.recalculateAndUpdate);
    window.addEventListener('pageshow', this.recalculateAndUpdate);

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick);
    });

    if (this.topButton) {
      this.topButton.addEventListener('click', this.handleTopClick);
    }

    window.requestAnimationFrame(() => {
      this.recalculateAndUpdate();
      setTimeout(this.recalculateAndUpdate, 300);
      setTimeout(this.recalculateAndUpdate, 1000);
    });
  }

  getStickyOffset() {
    const headers = [
      document.querySelector('sticky-header'),
      document.querySelector('.shopify-section-header-sticky'),
      document.querySelector('.section-header'),
      document.querySelector('.header-wrapper'),
      document.querySelector('header'),
    ];

    let offset = 0;

    headers.forEach((header) => {
      if (!header) return;

      const rect = header.getBoundingClientRect();
      const styles = window.getComputedStyle(header);

      const isFixedLike =
        styles.position === 'fixed' || styles.position === 'sticky';

      if (isFixedLike || rect.top <= 5) {
        offset = Math.max(offset, rect.bottom);
      }
    });

    return Math.max(0, offset);
  }

  getExpandedStickyHeight() {
    const clone = this.stickyCta.cloneNode(true);

    clone.style.position = 'fixed';
    clone.style.left = '0';
    clone.style.right = '0';
    clone.style.top = '0';
    clone.style.bottom = 'auto';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.zIndex = '-1';

    clone.classList.add('sticky-cta--is-stuck');
    clone.classList.add('sticky-cta--product-visible');
    clone.classList.remove('sticky-cta--tabs-only');

    document.body.appendChild(clone);

    const height = clone.offsetHeight;

    clone.remove();

    return height || this.stickyCta.offsetHeight;
  }

  getTrustBadgeTarget() {
    const elements = Array.from(document.querySelectorAll('body *'));

    const candidates = elements.filter((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();

      return (
        text.includes('Fully secure') &&
        text.includes('Trusted by') &&
        text.includes('Rated and reviewed')
      );
    });

    if (!candidates.length) return null;

    return candidates.reduce((smallest, current) => {
      const smallestArea = smallest.offsetWidth * smallest.offsetHeight;
      const currentArea = current.offsetWidth * current.offsetHeight;

      return currentArea < smallestArea ? current : smallest;
    });
  }

  calculateSwitchPoint() {
    const offset = this.getStickyOffset();
    const trustBadge = this.getTrustBadgeTarget();

    if (trustBadge) {
      const rect = trustBadge.getBoundingClientRect();

      /*
        到 trust badge 顶部碰到 header 下方时，
        bottom tabs 切换成 top CTA。
      */
      this.switchPoint = rect.top + window.scrollY - offset;
    } else {
      /*
        找不到 trust badge 时，fallback 到 reviews。
      */
      const fallback =
        document.querySelector('#shopify-product-reviews') ||
        document.querySelector('[id*="product-reviews"]') ||
        document.querySelector('[id*="ProductSpecs"]');

      if (fallback) {
        const rect = fallback.getBoundingClientRect();
        this.switchPoint = rect.top + window.scrollY - offset;
      } else {
        this.switchPoint = window.innerHeight;
      }
    }

    document.documentElement.style.setProperty(
      '--sticky-cta-top-offset',
      `${offset}px`
    );
  }

  recalculateAndUpdate() {
    this.calculateSwitchPoint();
    this.handleScroll();
  }

  handleResize() {
    this.recalculateAndUpdate();
  }

  handleScroll() {
    const offset = this.getStickyOffset();

    document.documentElement.style.setProperty(
      '--sticky-cta-top-offset',
      `${offset}px`
    );

    const shouldMoveToTop = window.scrollY >= this.switchPoint;

    if (shouldMoveToTop) {
      if (!this.stickyCta.classList.contains('sticky-cta--is-stuck')) {
        this.stickyCta.classList.add('sticky-cta--animate-in');
      }

      this.stickyCta.classList.add('sticky-cta--is-stuck');
      this.stickyCta.classList.remove('sticky-cta--tabs-only');
      this.stickyCta.classList.add('sticky-cta--product-visible');
    } else {
      this.stickyCta.classList.remove('sticky-cta--is-stuck');
      this.stickyCta.classList.remove('sticky-cta--animate-in');
      this.stickyCta.classList.add('sticky-cta--tabs-only');
      this.stickyCta.classList.remove('sticky-cta--product-visible');
    }

    this.updateActiveTab(offset);
  }

handleTabClick(event) {
  const tab = event.currentTarget;
  const href = tab.getAttribute('href');

  if (!href || !href.startsWith('#')) return;

  const target = this.getTabSection(tab) || document.querySelector(href);

  if (!target) return;

  event.preventDefault();

  /*
    如果 target 是 accordion details，先打开。
    这样 scroll 的时候不会跳到折叠前的位置。
  */
  if (target.tagName && target.tagName.toLowerCase() === 'details') {
    target.open = true;
  }

  this.tabs.forEach((item) => {
    item.classList.remove('is-active');
  });

  tab.classList.add('is-active');

  /*
    等 accordion 打开、sticky CTA 状态更新后再计算位置。
  */
  window.requestAnimationFrame(() => {
    const stickyOffset = this.getStickyOffset();
    const stickyHeight = this.stickyCta.getBoundingClientRect().height;

    /*
      BestBuy 效果：section row 贴在 sticky nav 下面，
      不额外留大空隙。
    */
    const targetTop =
      target.getBoundingClientRect().top +
      window.scrollY -
      stickyOffset -
      stickyHeight;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth',
    });
  });
}

  handleTopClick() {
    this.tabs.forEach((tab) => {
      tab.classList.remove('is-active');
    });

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

updateActiveTab(offset) {
  /*
    没超过 trust badge：
    bottom tabs 不显示任何 active。
  */
  if (window.scrollY < this.switchPoint) {
    this.tabs.forEach((tab) => {
      tab.classList.remove('is-active');
    });

    return;
  }

  const stickyHeight = this.stickyCta.getBoundingClientRect().height;

  /*
    active 判断线就在 sticky CTA 下面一点点。
    不要用 120，那会太早切。
  */
  const activationLine = window.scrollY + offset + stickyHeight + 4;

  let activeTab = null;
  let activeSectionTop = -Infinity;

  this.tabs.forEach((tab) => {
    if (tab.dataset.scrollActive !== 'true') return;

    const section = this.getTabSection(tab);

    if (!section) return;

    const sectionTop = section.getBoundingClientRect().top + window.scrollY;

    if (sectionTop <= activationLine && sectionTop > activeSectionTop) {
      activeSectionTop = sectionTop;
      activeTab = tab;
    }
  });

  this.tabs.forEach((tab) => {
    tab.classList.remove('is-active');
  });

  if (activeTab) {
    activeTab.classList.add('is-active');
  }
}

  getTabSection(tab) {
    const selectors =
      tab.dataset.sectionSelector || tab.getAttribute('href') || '';

    const selectorList = selectors
      .split(',')
      .map((selector) => selector.trim())
      .filter(Boolean);

    for (const selector of selectorList) {
      try {
        const section = document.querySelector(selector);

        if (section) return section;
      } catch (error) {
        // Ignore invalid selectors.
      }
    }

    return null;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sticky-cta--product-tabs').forEach((stickyCta) => {
    new ProductTabsStickyCTA(stickyCta);
  });
});